export const isEmail = (value) => {
  const validEmail =
    /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/ // NOSONAR
  return !validEmail.test(value)
}

export const isEmptyOrWhiteSpace = (str) => {
  const regex = /^\s*$/
  return regex.test(str)
}
export const validateCardNumber = (cardDigits) => {
  return cardDigits?.length < 4
}
export const validateExpiryDate = (expiryDate) => {
  const dateToValidate = expiryDate?.replace(/_/g, '')
  if (dateToValidate?.length <= 0) {
    return true
  }
  const date = dateToValidate.split('/')
  if (date.length < 2) {
    return true
  }
  const [month, year] = date

  return month?.length < 2 || year?.length < 2
}
